import {
    SET_HIGHLIGHTED_PRODUCT_IMAGE,
    SET_HIGHLIGHTED_PRODUCT_IMAGE_FAILURE,
    SET_HIGHLIGHTED_PRODUCT_IMAGE_SUCCESS,
} from 'store/actions/types';

export const setHighlightedProductImage = (payload) => {
    return {
        type: SET_HIGHLIGHTED_PRODUCT_IMAGE,
        payload: payload,
    };
};

export const setHighlightedProductImageFailure = (error) => {
    return {
        type: SET_HIGHLIGHTED_PRODUCT_IMAGE_FAILURE,
        error: error,
    };
};

export const setHighlightedProductImageSuccess = (productId, response) => {
    return {
        type: SET_HIGHLIGHTED_PRODUCT_IMAGE_SUCCESS,
        productId,
        response: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/products/images/setHighlightedProductImage.js